require.register("app/ui/Loader", function(exports, require, module){
  $0
  
});

